import { Component, Input } from '@angular/core';
import { Recipient } from '../../models/recipient.model';
import { RecipientService } from '../../services/recipient.service';
import { generatePagination } from '../../utils/pagination.utils';
import { CryptoRecipient } from '../../models/crypto-recipient';


@Component({
  selector: 'app-crypto-recipients-list',
  standalone: false,
  templateUrl: './crypto-recipients-list.component.html',
  styleUrl: './crypto-recipients-list.component.css'
})
export class CryptoRecipientsListComponent {
  @Input() uuid!: string;
    recipients: CryptoRecipient[] = [];
    loading = false;
    nextPageUrl: string | null = null;
    previousPageUrl: string | null = null;
    currentPage = 1;
    totalPages = 1;
    pageNumbers: any = [];
    showCreateModal = false;
    newRecipient: any = {
      address: '',
      name: 'Moneco - Return',
    };

    constructor(private recipientService: RecipientService) {}

    ngOnInit(): void {
      this.loadRecipients(this.currentPage);
    }

    reset() {
      this.recipients = [];
      this.nextPageUrl = null;
      this.previousPageUrl = null;
      this.currentPage = 1;
      this.totalPages = 1;
      this.pageNumbers = [];
    }

    loadRecipients(page: number) {
      this.reset();
      this.loading = true;
      this.recipientService
        .getCryptoRecipients(this.uuid, page)
        .subscribe((response) => {
          this.recipients = response.results;
          this.nextPageUrl = response.next;
          this.previousPageUrl = response.previous;
          this.currentPage = page;

          const itemsPerPage = 20;
          this.totalPages = Math.ceil(response.count / itemsPerPage);
          this.pageNumbers = generatePagination(
            this.currentPage,
            this.totalPages
          );
          this.loading = false;
        });
    }

    goToNextPage() {
      if (this.nextPageUrl) {
        const nextPage = this.getPageNumber(this.nextPageUrl);
        this.loadRecipients(nextPage);
      }
    }

    goToPreviousPage() {
      if (this.previousPageUrl) {
        const prevPage = this.getPageNumber(this.previousPageUrl);
        this.loadRecipients(prevPage);
      }
    }

    private getPageNumber(url: string): number {
      if (!url) return 1;

      const queryString = url.split('?')[1];
      if (!queryString) return 1;

      const params = new URLSearchParams(queryString);
      const page = params.get('page');

      return page ? Number(page) : 1;
    }

    openCreateModal() {
      this.showCreateModal = true;
    }

    closeCreateModal() {
      this.showCreateModal = false;
    }

    createRecipient() {
      this.recipientService.createCryptoRecipient(this.uuid, this.newRecipient).subscribe({
        next: (res) => {
          this.closeCreateModal();
          this.loadRecipients(this.currentPage);
        },
        error: (err) => {
          console.error('Error creating recipient:', err);
        }
      });
    }
}
